import React, { useEffect, useMemo, useState } from "react";

const API = process.env.REACT_APP_API_URL || window.location.origin;

export default function Beans() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const r = await fetch(`${API}/api/beans`);
                const data = await r.json().catch(() => []);
                setItems(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Çekirdekler alınamadı:", error);
                setItems([]);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    const sortedItems = useMemo(() => {
        return [...items].sort((a, b) => a.name.localeCompare(b.name, "tr"));
    }, [items]);

    const getInitial = (name) => {
        if (!name) return "?";
        return name.trim().charAt(0).toUpperCase();
    };

    return (
        <div className="equipmentPage">
            <div className="container">
                <div className="equipmentPageHeader">
                    <h1 className="equipmentPageTitle">Çekirdekler</h1>
                    <p className="equipmentPageSubtitle">
                        Kullandığımız çekirdekleri inceleyebilirsiniz.
                    </p>
                </div>

                {loading ? (
                    <div className="equipmentEmpty">Yükleniyor...</div>
                ) : sortedItems.length === 0 ? (
                    <div className="equipmentEmpty">Henüz çekirdek eklenmemiş.</div>
                ) : (
                    <div className="equipmentGrid">
                        {sortedItems.map((item) => (
                            <div className="equipmentCard" key={item.id}>
                                <div className="equipmentCardMedia">
                                    {item.imageUrl ? (
                                        <img
                                            src={`${API}${item.imageUrl}`}
                                            alt={item.name}
                                            className="equipmentCardImage"
                                        />
                                    ) : (
                                        <div className="equipmentCardFallback">
                                            {getInitial(item.name)}
                                        </div>
                                    )}
                                </div>

                                <div className="equipmentCardBody">
                                    <h3 className="equipmentCardTitle">{item.name}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}